/* eslint-disable */

let postType, getJSON;
// const jardinTerroirData = require('../data_jardin.json');
// const agricultureData = require('../data_agriculture.json');
// const materiauxData = require('../data_materiaux.json');
const pagePole = document.querySelector('body.page-template-template-pole');


if (pagePole) {

  if (document.querySelector('body.jardin-et-terroir')) {
    postType = 'map_jardin';
    // getJSON = jardinTerroirData;
  } else if (document.querySelector('body.agriculture')) {
    postType = 'map_agriculture';
    // getJSON = agricultureData;
  } else if (document.querySelector('body.materiaux-et-energies')) {
    postType = 'map_materiaux';
    // getJSON = materiauxData;
  }


  const map = document.querySelector('#map-page-interne');
  let markers = [];

  if (map) {

    // const finalDATA = [];
    // getJSON.forEach(obj => {
    //   finalDATA.push({
    //     name: obj.nom,
    //     address: `${obj.adresse} <br> ${obj.code_postal}, ${obj.ville}`,
    //     tel: obj.tel,
    //     lng: obj.long,
    //     lat: obj.lat,
    //     color_hex: obj.couleur_hex,
    //     color_name: obj.couleur_nom
    //   })
    // })

    mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2tsMTB4azNvNjFraDJwcXQwNWh6YTR2NCJ9.6kPngUiEjRlDSZWLf6PXhw';
    var map2 = new mapboxgl.Map({
      container: 'map-page-interne', // container ID
      style: 'mapbox://styles/mapbox/streets-v11', // style URL
      center: [6.380653834639104, 49.023601978636115], // starting position [lng, lat]
      zoom: 7 // starting zoom
    });

    const fetchData = () => {
      let form = new FormData();
      form.append('action', 'load_locations');
      form.append('post_type', postType);

      fetch(wpjs.ajaxurl, {
        method: 'POST',
        body: form
      })
        .then(response => response.json())
        .then(response => {
          console.log(response)
          initMarkers(response);
        })
    }



    function setMarker(marker) {
      const markerHTML = document.createElement('div');
      markerHTML.className = "marker";
      markerHTML.setAttribute('data-color', marker.couleur_nom)
      let htmlContent = '';
      if (marker.display_link) {
        htmlContent = `
        <div class="popup_name">${marker.nom} </div>
        <p class="popup_address">${marker.adresse}</p>
        <p class="popup_address">${marker.code_postal},${marker.ville}</p>
        <a href="tel:${marker.tel}">${marker.tel}</a>
        <a class="link_magasin" href="${marker.permalink}">Voir magasin</a>`;
      } else {
        htmlContent = `
        <div class="popup_name">${marker.nom} </div>
        <p class="popup_address">${marker.adresse}</p>
        <p class="popup_address">${marker.code_postal},${marker.ville}</p>
        <a href="tel:${marker.tel}">${marker.tel}</a>`;
      }
      const popup = new mapboxgl.Popup({ offset: 25 })
      popup.setHTML(htmlContent);


      return new mapboxgl.Marker({ element: markerHTML })
        .setLngLat([marker.long, marker.lat])
        .setPopup(popup) // add popups
        .addTo(map2);
    }

    function initMarkers(data) {
      markers = [];

      data.forEach((marker) => {
        let m = setMarker(marker)

        markers.push({
          couleur: marker.couleur_nom,
          marker: m
        })
      });
    }

    map2.on('load', fetchData)

    const legends = document.querySelectorAll('.map-legends .legend')
    if (legends.length) {
      legends.forEach(l => {
        l.onclick = function (e) {
          e.preventDefault()
          e.stopPropagation()
          let color = this.dataset.color

          markers.filter((m) => m.couleur != color).map(m => {
            m.marker.remove()
          })
          markers.filter((m) => m.couleur === color).map(m => {
            m.marker.addTo(map2)
          })
        }
      })
    }


    // finalDATA.forEach(obj => {
    //   const marker = document.createElement('div');
    //   marker.className = "marker";
    //   marker.setAttribute('data-color', obj.color_name)
    //   const popup = new mapboxgl.Popup({ offset: 25 })
    //   popup.setHTML('<div class="popup_name">' +
    //     obj.name +
    //     '</div><p class="popup_address">' +
    //     obj.address +
    //     '</p>' +
    //     '<a href=tel:' +
    //     obj.tel +
    //     '>' +
    //     obj.tel +
    //     '</a>');


    //   new mapboxgl.Marker({ element: marker })
    //     .setLngLat([obj.lng, obj.lat])
    //     .setPopup(popup) // add popups
    //     .addTo(map2);



    // });


    document.body.onclick = () => {
      document.querySelector('.mapboxgl-popup.mapboxgl-popup-anchor-bottom').remove();
    }

    document.querySelector('#map-page-interne').onclick = e => e.stopPropagation();
  }

  const anchorLinks = document.querySelectorAll('.anchor-pole > a');

  anchorLinks[0].classList.add('is_active')

  function resetChanges(filters) {
    filters.forEach(item => {
      if (item.classList.contains('is_active')) {
        item.classList.remove('is_active');
      }
    })
  }

  anchorLinks.forEach(filter => {
    filter.onclick = function () {
      resetChanges(anchorLinks);
      this.classList.add('is_active');
    }
  })

  if ('IntersectionObserver' in window) {

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(entry => {

          if (entry.isIntersecting) {
            anchorLinks.forEach(filter => {
              if (filter.dataset.id == entry.target.id) {
                resetChanges(anchorLinks);
                filter.classList.add('is_active');
              }
            })
          }
        })
      }, { threshold: 0.1 });

    const targets = document.querySelectorAll('.content-wrapper');
    targets.forEach(e => observer.observe(e))
  }
}





// WEBPACK FOOTER //
// ./scripts/pole.js